export const NOTIFICATION_POLLING_TIME_MS = 15000;
